import { render, staticRenderFns } from "./SystemApps.vue?vue&type=template&id=e568a596&scoped=true"
import script from "./SystemApps.vue?vue&type=script&lang=js"
export * from "./SystemApps.vue?vue&type=script&lang=js"
import style0 from "./SystemApps.vue?vue&type=style&index=0&id=e568a596&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e568a596",
  null
  
)

export default component.exports